/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import type { ImpersonateModal } from "@modules/employee/reducer/user-account-details/types";

type OwnProps = $Exact<{
  modal: ImpersonateModal,
  onDismissHandler: () => void,
  onSubmit: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const ConfirmImpersonateModal = (props: Props) => (
  <Modal className="modal-small">
    <ModalHeader toggle={props.onDismissHandler}>{props.t("IMPERSONATE")}</ModalHeader>
    <ModalBody className="d-flex flex-column justify-content-center align-items-center">
      <p className="normal-font-size text-center">
        {props.t("IMPERSONATE_CONFIRM", { name: props.modal.employeeName })}
      </p>
      <p className="text-pumpkin-orange text-center">
        <b>{props.t("IMPORTANT_NOTE")}</b>
        {props.t("IMPERSONATE_NOTE")}
      </p>
    </ModalBody>
    <ModalFooter>
      <Button onClick={props.onDismissHandler} color="secondary">
        {props.t("CANCEL")}
      </Button>
      <Button onClick={props.onSubmit}>{props.t("PROCEED")}</Button>
    </ModalFooter>
  </Modal>
);

export default localize()(ConfirmImpersonateModal);
